<template>
  <form class="popup form" novalidate @submit.prevent>
    <div v-if="showBanner" class="popup__banner">
      <slot name="banner" />
    </div>
    <div class="popup__main">
      <section class="popup__content">
        <slot name="main" />
      </section>
    </div>
    <div v-if="showActions" class="popup__actions">
      <slot name="actions" />
    </div>
    <slot name="overlay" />
  </form>
</template>

<script>
export default {
  computed: {
    showActions() {
      // Only show popup actions when slot content available
      return !!this.$slots.actions
    },
    showBanner() {
      // Only show popup banner when slot content available
      return !!this.$slots.banner
    },
  },
  name: 'PopupStickyBar',
  props: {
    actionTitle: {
      default: '',
      type: String,
    },
    /**
     * Route path for back link
     */
    backPath: {
      default: '',
      type: String,
    },
    /**
     * Route query for back link
     */
    backQuery: {
      default: () => {},
      type: Object,
    },
  },
}
</script>

<style scoped>
.popup {
  @apply flex flex-col w-full h-full;
  @apply bg-white shadow overflow-y-auto;

  /* Popup banner */
  & .popup__banner {
    @apply sticky top-0 w-full z-10;
  }

  & .popup__actions {
    @apply p-2;
  }
}

/* Popup main content */
.popup__main {
  @apply flex-1 flex flex-col;
  @apply relative overflow-x-hidden;
}
</style>
